import React from 'react'
import Typography from '@material-ui/core/Typography';
import Card from '../../common/Card';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';

export default ({ nome, cpfcnpj, legadoId }) => {
  return (
    <React.Fragment>
      <Card isCustomStyle style={{ marginRight:'10px'}}>

        <Typography variant="subtitle1" style={{textAlign:"center", fontSize: '1.5rem'}}>CLIENTE</Typography>
        <List>
          <ListItem style={{display:'flex', justifyContent:'space-between'}}>
            <Typography style={{ fontSize: '0.8rem'}}>CÓDIGO ERP:</Typography>
            <Typography style={{ fontSize: '1.3rem'}}>{legadoId}</Typography>
          </ListItem>
          <ListItem style={{display:'flex', justifyContent:'space-between'}}>
            <Typography style={{ fontSize: '0.8rem'}}>NOME:</Typography>
            <Typography style={{ fontSize: '1.3rem', textAlign:"right"}}>{nome}</Typography>
          </ListItem>
          <ListItem style={{display:'flex', justifyContent:'space-between'}}>
            <Typography style={{ fontSize: '0.8rem'}}>CNPJ/CPF:</Typography>
            <Typography style={{ fontSize: '1.3rem'}}>{cpfcnpj}</Typography>
          </ListItem>
        </List>
      </Card>
    </React.Fragment>
  )
}
